module.exports = __webpack_public_path__ + "img/CNYCandy.93a2f547.svg";